// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Join types enum.
 */
export enum JoinTypeEnum {
  Cross = 0,
  Inner = 1,
  Full = 2,
  Left = 3,
  Right = 4,
  FullOuter = 5,
  LeftOuter = 6,
  RightOuter = 7
}
